import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    locations: [],
    totalLocations: null,
    perPageForLocations: 5,
    currentPageForLocations: 1,
    tableLoading: false,
    logs: [],
    totalLogs: null,
    perPageForLogs: 5,
    currentPageForLogs: 1,
    searchQuery: "",
    filterDate: "",
    filterStatus: "",
  },
  actions,
  mutations,
};
